import { createAction, handleActions } from 'redux-actions';
import produce from 'immer';
import { postCheckLimitForward } from 'app/api';

const CHANGE_STATE = 'loan.sendLimitCheck/CHANGE_STATE';
export const changeStateAction = createAction(CHANGE_STATE);

const POST_LIMIT_INQUIRY_FORWARD_BY_DEALER = 'loan.sendLimitCheck/POST_LIMIT_INQUIRY_FORWARD_BY_DEALER';
export const postCheckLimitForwardAction = createAction(POST_LIMIT_INQUIRY_FORWARD_BY_DEALER, postCheckLimitForward);

const initialState = {
	phnno: '',
	carNo: '',
	statusSendUri: '',
};

export default handleActions(
	{
		[CHANGE_STATE]: (state, action) =>
			produce(state, (draft) => {
				const { name, value } = action.payload;
				draft[name] = value;
			}),
	},
	initialState,
);
